import { Control } from "@react-typed-forms/core";
import {
  createFormTree,
  createSchemaDataNode,
  createSchemaLookup,
  FormRenderer,
  RenderForm,
  SchemaField,
} from "@react-typed-forms/schemas";
import { FormDefinitions } from "./formDefs";
import { SchemaMap } from "./schemas";
import { formRenderer } from "./renderer";
import { useMemo } from "react";

export type FormType = keyof typeof FormDefinitions;

export const schemaLookup = createSchemaLookup(
  SchemaMap as Record<string, SchemaField[]>,
);

interface AppFormProps<T> {
  formType: FormType;
  data: Control<T>;
  renderer?: FormRenderer;
}

export function AppForm<T>({ formType, data, renderer }: AppFormProps<T>) {
  const formDef = FormDefinitions[formType];
  const formTree = useMemo(() => createFormTree(formDef.controls), [formDef]);
  // `!` because every generated FormDefinition references a registered schema name.
  const schemaNode = schemaLookup.getSchema(formDef.schemaName)!;

  return (
    <RenderForm
      data={createSchemaDataNode(schemaNode, data)}
      form={formTree.rootNode}
      renderer={renderer ?? formRenderer}
    />
  );
}
